<h2 mat-dialog-title class="tw-m-0 tw-text-lg tw-font-semibold">Transactions with same id</h2>
<div
  appGlossScroll
  mat-dialog-content
  class="tw-max-h-[70vh] tw-overflow-y-auto tw-min-w-[min(90vw,36rem)]"
>
  <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-mb-3">
    <p class="tw-text-sm tw-text-dt-text-secondary tw-m-0">
      id:
      <span class="tw-font-mono tw-break-all">{{ data.sharedId }}</span>
      · {{ data.transactions.length }} vault row(s)
    </p>
    <button type="button" mat-stroked-button class="tw-text-xs tw-shrink-0" (click)="copyAll()">
      Copy All JSON
    </button>
  </div>
  @for (tx of data.transactions; track $index) {
    <div class="tw-mb-6 tw-last:tw-mb-0">
      <div
        class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-text-xs tw-font-mono tw-text-dt-text-secondary tw-mb-2"
      >
        <span>vid: {{ tx.vid ?? "—" }} · dc: {{ tx.dc ?? "—" }}</span>
        <button
          type="button"
          mat-stroked-button
          class="tw-text-xs tw-shrink-0"
          (click)="copyOne(tx)"
        >
          Copy
        </button>
      </div>
      <pre
        appGlossScroll
        class="tw-m-0 tw-text-xs tw-font-mono tw-max-h-48 tw-overflow-auto tw-p-3 tw-bg-neutral-900 tw-text-dt-text-disabled tw-rounded tw-whitespace-pre-wrap tw-break-words tw-select-all gs-dark"
        >{{ txJson(tx) }}</pre
      >
    </div>
  }
  @if (data.transactions.length === 0) {
    <p class="tw-text-sm tw-text-dt-text-tertiary tw-m-0">No transactions found.</p>
  }
</div>
<div mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button mat-button mat-dialog-close type="button">Close</button>
</div>
